import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trash2 } from 'react-feather';
import { DeleteCreditCardPolicy } from 'actions';
import ButtonToolbar from 'components/button-toolbar';
import ContactStrip from 'components/contact-strip';
import ConfirmAction from 'components/confirm-action';
import Loading from 'components/loading';
import { Back, Button } from 'components/quashed';
import Title from 'components/title';
import { DASHBOARD_ROUTE } from 'constants/routes';
import history from 'helpers/history';
import { selectCreditCardDetails } from 'selectors';
import CreditCardCovers from './components/CreditCardCovers';
import styles from './styles/PolicyDetailsContainer.module.scss';

interface IProps {
  policyId: string;
}

const getToolbarItems = (creditCard) => {
  if (creditCard) {
    return creditCard.benefits.map(R.pick(['name']));
  }
  return [];
};

const PolicyDetailsCreditCard = ({ policyId }: IProps) => {
  const dispatch = useDispatch();
  const { policy, creditCardInfo, isOwner, loading } = useSelector((state) =>
    selectCreditCardDetails(state, policyId),
  );
  const [openConfirm, setConfirm] = useState(false);
  const toolbarItems = getToolbarItems(creditCardInfo);
  const [active, setActive] = useState(null);

  if (loading) {
    return <Loading />;
  }

  const handleMenuClick = ({ name }) => setActive(name);

  const handleConfirmCancel = () => setConfirm(false);

  const handleConfirmOpen = () => setConfirm(true);

  const handleConfirm = () => {
    history.push(DASHBOARD_ROUTE);
    setConfirm(false);
    dispatch(DeleteCreditCardPolicy(policyId, policy.sk));
  };

  const activeBenefit = active || toolbarItems[0]?.name;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title
          className={styles.ccTitle}
          img={`https:${creditCardInfo.cardImageUrl}`}
          title={creditCardInfo.name}
        />
        <ContactStrip {...creditCardInfo} />
      </div>

      <ButtonToolbar
        items={toolbarItems}
        active={activeBenefit}
        onClick={handleMenuClick}
        responsive={true}
      />
      {activeBenefit && (
        <CreditCardCovers active={activeBenefit} {...creditCardInfo} />
      )}

      {isOwner && (
        <div className={styles.buttons}>
          <Button
            className={styles.ccSubmit}
            onClick={handleConfirmOpen}
            inverted={true}
          >
            <Trash2 size={20} />
            Remove card
          </Button>
          <Back
            className={styles.ccBack}
            link={DASHBOARD_ROUTE}
            text="Back to dashboard"
          />
        </div>
      )}
      <ConfirmAction
        open={openConfirm}
        header="Delete Credit Card"
        content="Are you sure you want to delete this credit card?"
        onCancel={handleConfirmCancel}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default PolicyDetailsCreditCard;
